export default __webpack_public_path__ + "static/e-commerce-swipe-to-like-3b7119a6205d208de0898f5e1af235de.gif";